import type { FooterColumn, NavLink } from '@/types'

export const primaryNav: NavLink[] = [
    { label: 'Services', href: '/services' },
    { label: 'About', href: '/about' },
    { label: 'Gallery', href: '/work' },
    { label: 'Blog', href: '/blogs' }
]

export const footerColumns: FooterColumn[] = [
    {
        title: 'COMPANY',
        links: [
            { label: 'Homepage', href: '/' },
            { label: 'About Us', href: '/about' },
            { label: 'Our Services', href: '/services' },
            { label: 'Gallery', href: '/work' },
            { label: 'Reviews', href: '/reviews' }
        ]
    },
    {
        title: 'PAGES',
        links: [
            { label: 'Blog', href: '/blogs' },
            { label: 'FAQ', href: '/faqs' },
            { label: 'Contact Us', href: '/contact' },
            { label: 'Free Estimate', href: '/book-free-consultation' }
        ]
    },
    {
        title: 'RESOURCES',
        links: [
            { label: 'Privacy Policy', href: '/privacy-policy' },
            { label: 'Cookies', href: '/privacy-policy#cookies' },
            { label: 'Warranty', href: '/terms-and-conditions' },
            { label: 'Our Process', href: '/#process' }
        ]
    }
]

/**
 * Social profiles shown in the footer. NG Painting Pro does not list any
 * social accounts, so this stays empty and the footer hides the row.
 * Add `{ label, href, icon, hoverIcon }` entries here to show them.
 */
export const socialLinks: {
    label: string
    href: string
    icon: string
    hoverIcon: string
}[] = []
